import UUIDBase from '@/models/UUIDBase'
import { useI18nInstance, localizeFieldName } from '@/plugins/i18n'
import DeliveryAttachment from "@/models/delivery/DeliveryAttachment";
import InsuranceAttachment from "@/models/insurance/InsuranceAttachment";

const { t } = useI18nInstance().global

export const insuranceI18nMessages = {
  en: {
    name: 'Insurance name',
    contactFirstName: 'Contact First Name',
    contactLastName: 'Contact Last Name',
    contactDisplayName: 'Contact Full Name',
    email: 'Email',
    phone: 'Phone',

    streetAddress: 'Street Address',
    city: 'City',
    postalCode: 'Postal Code',
    country: 'Country'
  },
  ar: {
    name: 'اسم شركة التأمين',
    contactFirstName: 'اسم جهة الاتصال',
    contactLastName: 'لقب جهة الاتصال',
    contactDisplayName: 'جهة الاتصال',
    email: 'البريد الالكتروني',
    phone: 'رقم الهاتف',

    streetAddress: 'عنوان الشركة',
    city: 'المدينة',
    postalCode: 'الرمز البريدي',
    country: 'الدولة'
  }
}

export default class Insurance extends UUIDBase {
  static from(json: Record<string, unknown> | Insurance) {
    return Object.assign(new Insurance(), json)
  }
  static ENDPOINT = '/company/insurance'

  name = ''

  contactFirstName = ''
  contactLastName = ''
  email = ''
  phone = ''

  streetAddress = ''
  city = ''
  postalCode = ''
  country = ''
  insuranceAttachments: Array<InsuranceAttachment> = [];

  get contactDisplayName() {
    return `${this.contactFirstName} ${this.contactLastName}`
  }

  validateName() {
    if (this.name.length === 0) {
      return t('validation.required', {
        field: localizeFieldName('name', insuranceI18nMessages)
      })
    } else if (this.name.length > 255) {
      return t('validation.maxLength', {
        field: localizeFieldName('name', insuranceI18nMessages)
      })
    }
  }
}
